import Types from "./Types";

const INITIAL_STATE = {
  exams: [],
  allExams: [],
  allHomeworks: [],
  chapterExams: [],
  chapterExam: [],
  chapterExamDetails: [],
  chapterExamAnswers: [],
  examQuestions: [],
  examQuestionsLoadError: null,
  studentExamCreatedAt: null,
  studentExamTimeError: false,
  examCorrection: {},
  isAnswersLoading: false,
  exam: {},
  isLoading: false,
  count: "",
  // Daily Challenge
  todayChallenge: null,
  todayChallengeQuestions: [],
  todayChallengeExamId: null,
  challengeCorrection: null,
  previousChallenges: [],
  streakLeaderboard: {
    users: [],
    users_subject: [],
    users_score: null,
    users_subject_score: null,
    users_score_this_month: null,
    users_subject_score_this_month: null,
  },
};

export default function chapterExams(state = INITIAL_STATE, action) {
  const { type, payload } = action;
  switch (type) {
    case Types.GET_ALL_EXAMS_SUCCESS: {
      return {
        ...state,
        exams: payload.data,
      };
    }
    case Types.GET_ALL_EXAMS_AND_HOMEWORKS_SUCCESS: {
      const body = payload?.data ?? payload ?? {};
      const exams = Array.isArray(body.exams)
        ? body.exams
        : Array.isArray(body?.data?.exams)
          ? body.data.exams
          : [];
      const homeworks = Array.isArray(body.homeworks)
        ? body.homeworks
        : Array.isArray(body?.data?.homeworks)
          ? body.data.homeworks
          : [];
      return {
        ...state,
        allExams: exams,
        allHomeworks: homeworks,
      };
    }
    case Types.GET_CHAPTER_EXAM_SUCCESS: {
      return {
        ...state,
        chapterExam: payload.data,
      };
    }
    case Types.GET_CHAPTER_EXAM_DETAILS_SUCCESS: {
      return {
        ...state,
        chapterExamDetails: payload.data,
      };
    }

    case Types.GET_EXAMS_BY_CHAPTER_ID_SUCCESS: {
      return {
        ...state,
        chapterExams: payload.data,
        count: payload.data.length,
      };
    }

    case Types.GET_EXAMS_BY_ID_SUCCESS: {
      const exam = payload?.data ?? payload ?? {};
      return {
        ...state,
        exam: Array.isArray(exam) ? {} : exam,
      };
    }

    case Types.GET_EXAM_QUESTIONS_REQUEST: {
      return {
        ...state,
        studentExamCreatedAt: null,
        studentExamTimeError: false,
      };
    }
    case Types.GET_EXAM_QUESTIONS_SUCCESS: {
      return {
        ...state,
        examQuestions: payload.data,
        examQuestionsLoadError: null,
      };
    }
    case Types.GET_EXAM_QUESTIONS_FAIL: {
      return {
        ...state,
        examQuestionsLoadError: payload || null,
      };
    }
    case Types.GET_STUDENT_EXAM_SUCCESS: {
      return {
        ...state,
        studentExamCreatedAt: payload || null,
        studentExamTimeError: false,
      };
    }
    case Types.GET_STUDENT_EXAM_FAIL: {
      return {
        ...state,
        studentExamCreatedAt: null,
        studentExamTimeError: true,
      };
    }
    case Types.GET_EXAM_CORRECTION_SUCCESS: {
      return {
        ...state,
        examCorrection: payload.data,
      };
    }

    case Types.ADD_EXAMS_LOADING: {
      return {
        ...state,
        isLoading: payload,
      };
    }
    case Types.SEND_ANSWERS_LOADING: {
      return {
        ...state,
        isAnswersLoading: payload,
      };
    }
    case Types.SEND_ANSWERS_SUCCESS: {
      return {
        ...state,
      };
    }
    case Types.EXAM_REDO_SUCCESS: {
      return {
        ...state,
      };
    }

    // Daily Challenge
    case Types.GET_TODAY_CHALLENGE_SUCCESS: {
      return {
        ...state,
        todayChallengeQuestions: payload.data || [],
        todayChallengeExamId: payload.exam_id || null,
      };
    }

    case Types.COMPLETE_TODAY_CHALLENGE_SUCCESS: {
      return {
        ...state,
        challengeCorrection: payload.data || null,
      };
    }

    case Types.GET_PREVIOUS_CHALLENGES_SUCCESS: {
      return {
        ...state,
        previousChallenges: Array.isArray(payload) ? payload : (payload.data || []),
      };
    }

    case Types.GET_STREAK_LEADERBOARD_SUCCESS: {
      return {
        ...state,
        streakLeaderboard: {
          users: payload.data?.users || [],
          users_subject: payload.data?.users_subject || [],
          users_score: payload.data?.users_score || null,
          users_subject_score: payload.data?.users_subject_score || null,
          users_score_this_month: payload.data?.users_score_this_month || null,
          users_subject_score_this_month: payload.data?.users_subject_score_this_month || null,
        },
      };
    }

    case Types.CLEAR_DAILY_CHALLENGE_STATE: {
      return {
        ...state,
        todayChallengeQuestions: [],
        todayChallengeExamId: null,
        challengeCorrection: null,
      };
    }

    default: {
      return state;
    }
  }
}
